// ═══════════════════════════════════════════════════════════════
// HotWash — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconEye, IconPlus, IconUpload, IconChartBar,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import PageHeader from '../../components/ui/PageHeader';
import ModuleNav from '../../components/layout/ModuleNav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/hotwash', icon: IconLayoutDashboard, exact: true },
  { label: 'Observations', path: '/hotwash/observations', icon: IconEye },
  { label: 'Submit', path: '/hotwash/submit', icon: IconPlus },
  { label: 'Analytics', path: '/hotwash/analytics', icon: IconChartBar },
  { label: 'Import', path: '/hotwash/import', icon: IconUpload, minLevel: 'editor' },
];

export default function HotWashLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('hotwash', NAV_ITEMS);

  const isDetail = pathname.startsWith('/hotwash/incident/');

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
          <PageHeader
            breadcrumbs={[{ label: 'Recover' }, { label: 'After-Action Review' }]}
            title="After-Action Review"
            subtitle="Observations, analytics and lessons learned documentation"
          />
          <ModuleNav items={visibleItems} accentColor={brand.blurple} />
        </>
      )}
      <Outlet />
    </div>
  );
}
